"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFeatureDisabled = exports.isFeatureEnabled = exports.mapVendorFlags = exports.mergeFeatureFlagValues = void 0; // Merge function to allow f2 to overwrite f1

exports.mergeFeatureFlagValues = (f1, f2) => {
  const merged = {}; // Merge the two arrays of flag values into and object

  [f1, f2].forEach(featureArray => featureArray.forEach(featureValue => merged[featureValue.name] = featureValue));
  return Object.values(merged);
}; // Utility that turns a vendors feature flag values into an Object, so we can get O(1) lookups
// This is to be used by client applications to manage their own cache


exports.mapVendorFlags = featureFlags => {
  return featureFlags.reduce((map, feature) => {
    map[feature.name] = feature;
    return map;
  }, {});
}; // Utility that checks if a feature flag is enabled. It looks into a featuresMap passed as the first argument


exports.isFeatureEnabled = (featuresMap, featureName) => {
  var _a;

  return !!((_a = featuresMap[featureName]) === null || _a === void 0 ? void 0 : _a.value);
}; // Utility that checks if a feature flag is disabled. It looks into a featuresMap passed as the first argument


exports.isFeatureDisabled = (featuresMap, featureName) => {
  return !exports.isFeatureEnabled(featuresMap, featureName);
};